import { useTranslation } from 'react-i18next';
import { CONTEXTS } from 'components/Wizards/utils';
import { StyledDnDColumns } from './styles';

const dummyFn = () => false;

export const DraggableColumns = ({
  onChange,
  leftItems,
  rightItems,
  itemsOrdering,
}) => {
  const { t } = useTranslation();
  return (
    <StyledDnDColumns
      initialLeftColumnItems={leftItems}
      initialRightColumnItems={rightItems}
      previewLabel={t('Column Preview')}
      searchPlaceholder={t('Find Options')}
      leftHeaderText={t('Available Columns (Drag to Add)')}
      rightHeaderText={t('Active Table Columns')}
      renderRightEmpty={{
        onDropLabel: t('Place Here'),
        noItems: t('No Columns Currently Selected (Drag and Drop to Add)'),
      }}
      renderLeftEmpty={{
        onDropLabel: t('Drop to Remove'),
        noItems: t('No Options Found'),
      }}
      onChange={onChange}
      iconVisible={dummyFn}
      iconEditable={dummyFn}
      colorEditable={dummyFn}
      context={CONTEXTS.fields}
      showCategoryOnSearch={false}
      grouped
      itemsOrdering={itemsOrdering}
    />
  );
};
